
export default function WhyChooseServices() {
  const features = [
    {
      icon: 'ri-award-line',
      title: 'QCDD Approved Service Provider',
      description: 'All our services meet Qatar Civil Defence Department standards and regulations.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Experienced Engineers & Technicians',
      description: 'Our certified team brings years of expertise in fire safety solutions.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Fast Support & Reliable Maintenance',
      description: '24/7 emergency support and scheduled maintenance to keep systems operational.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Full Compliance with Qatar Safety Standards',
      description: 'Every installation and service meets local building codes and safety requirements.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose FlameGuardQA</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine technical expertise, regulatory compliance, and reliable service 
            to deliver fire safety solutions you can trust.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-lg text-center hover:shadow-xl hover:bg-red-50 transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-6 group-hover:bg-red-600 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-red-600 group-hover:text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4 group-hover:text-red-600 transition-colors">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-white rounded-2xl p-12 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Professional Fire Safety Services Across Qatar
              </h3>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                From initial consultation to ongoing maintenance, we provide comprehensive 
                fire protection services for commercial, industrial, and residential properties. 
                Our team ensures every system meets QCDD requirements and operates at peak performance.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">1000+</div>
                  <p className="text-gray-600">Systems Installed</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">24/7</div>
                  <p className="text-gray-600">Emergency Support</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20team%20in%20Qatar%20working%20on%20comprehensive%20fire%20protection%20system%20installation%2C%20certified%20engineers%20and%20technicians%20with%20QCDD%20approved%20equipment%2C%20modern%20commercial%20building%20with%20complete%20fire%20safety%20infrastructure%20and%20red%20safety%20equipment&width=600&height=400&seq=professional-team&orientation=landscape"
                alt="Professional Fire Safety Team"
                className="rounded-2xl shadow-xl object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}